for (let form of document.getElementsByClassName('.community-selector')) {
  form.addEventListener('submit', processCommunityUpdateEvent);
}

function geoip(userGeoIP) {

// This function gets called when the geoip script is loaded
  if (NorthernShopper.communities.hasOwnProperty(userGeoIP.city)) {
    updateCommunity(userGeoIP.city);
  } else { // Let's loop through all the alternate names and check
    for (const [communityName, community] of Object.entries(NorthernShopper.communities)) {
      if (community.alternate_names && community.alternate_names.includes(userGeoIP.city)) {
        updateCommunity(communityName);
      }
    }
  }
}

function setupBarcodeScanner() {

  let barcode = "";
  let reading = false;
  const ENTER_KEY_VALUE = 13;
  const TIMEOUT_TIME_IN_MS = 300;
  let timeout = null;

  document.addEventListener('keypress', e => {

// usually scanners throw an 'Enter' key at the end of read
    if (e.keyCode === ENTER_KEY_VALUE) {

      if (barcode.length > 3) {
        console.log(`Sending Barcode: ${barcode}`);
        let event = new CustomEvent('barcodescanned', {
          bubbles: true,
          cancelable: true,
          detail: barcode
        });
        document.dispatchEvent(event);

// code ready to use
        barcode = "";
        clearTimeout(timeout);
        reading = false;
      }
    } else {
      barcode += e.key;


// while this is not an 'enter' it stores the every key
// console.log(`Updating Barcode: ${barcode}`);
      if (! reading) {
        reading = true;
        timeout = setTimeout(() => {
          console.log(`Resetting Barcode: ${barcode}`);
          barcode = "";
          reading = false;
        }, TIMEOUT_TIME_IN_MS);
      }
    }
  });

}
setupBarcodeScanner();

document.addEventListener('barcodescanned', (e) => {
  console.log("Barcode Caught:", e.detail);
  let barcode = e.detail;

// Let's try to add it to the cart
  let quantity = 1;

  let cart = BoosterTheme
    .cart
    .minicart
    .data
    .items;

  if (barcode in cart) {
    cart[barcode].quantity += 1;
    quantity = cart[barcode].quantity;
  }
  console.log(`Setting QTY to ${quantity} for product ${barcode}`);

  BoosterTheme.cart.updateQuantity(e, barcode, quantity, true);

});

document.addEventListener('booster:cart:update', (e) => {
  if (document.body.classList.contains('template--cart')) { // ignore the cart page
    return;
  }

  console.log("Updating card based on cart:");

// We are going to update the cards and the order guides
  let cart = BoosterTheme
    .cart
    .minicart
    .data
    .items;

  let allProductCards = document.querySelectorAll(`.card--default[data-product-id]`);
  for (const productCard of allProductCards) { // check if it is in the card.
    const variantId = productCard.getAttribute('data-product-id');
    let quantity = 0;
    if (variantId in cart) {
      quantity = cart[variantId].quantity;
    }

    productCard.setAttribute("data-cart-value", quantity);

    let image = productCard.querySelector('.card__img--container');
    if (image) {
      image.setAttribute("data-cart-value", quantity);
    }

    let input = productCard.querySelector(".quantity--input__input");
    if (input && (input.getAttribute('value') != quantity || input.value != quantity)) {
      input.setAttribute("value", quantity);
      input.value = quantity;
    }

  }
});